import { lang } from "@umu/ukit-lang";
import { MICRO_PAGE_TEMPLATE } from "@umu/umu-types";

const microPageTemplateMapInfo: Record<MICRO_PAGE_TEMPLATE, {
    title: string;
}> = {
    [MICRO_PAGE_TEMPLATE.__INIT__]: {
        title: lang('所有类型')
    },
    [MICRO_PAGE_TEMPLATE.CUSTOM_TEMPLATE]: {
        title: lang('用户创建')
    },
    [MICRO_PAGE_TEMPLATE.SYSTEM_TEMPLATE]: {
        title: lang('系统模板')
    },
}

export {
    microPageTemplateMapInfo
}
